import { action, makeObservable, onBecomeObserved, override } from "mobx"

import {
  getOnRampPaymentsMock,
  ON_RAMP_PAYMENTS_MOCK_KEY,
} from "@src/app/mocks/onRampPaymentsMock"
import { transactionsOnRampFilters } from "@src/pages/transactionsOnRamp/constants"
import { catchErrors, onRampApi } from "@src/shared/api"
import {
  OnRampPaymentResponse,
  OnRampPaymentResponseStatusEnum,
  Pagination,
} from "@src/shared/api/generated"
import { registerCollectionMock } from "@src/shared/classes/Collection/collectionMocks"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"
import { CollectionFilters } from "@src/shared/componemts/TableFilter/classes/CollectionFilters"

registerCollectionMock(ON_RAMP_PAYMENTS_MOCK_KEY, getOnRampPaymentsMock)

export type OnRampPaymentsLoadRequest = {
  date?: {
    dateFrom?: string
    dateTo?: string
  }
  order?: "asc" | "desc"
  page?: number
  projectId?: string
  status?: OnRampPaymentResponseStatusEnum
}

export type OnRampPaymentsCollectionFilters = {
  date?: {
    dateFrom?: string
    dateTo?: string
  }
  order?: "asc" | "desc"
  projectId?: string
  status?: OnRampPaymentResponseStatusEnum
}

export class OnRampPaymentsCollection extends loading(
  ["fetch"],
  CollectionWithPagination<OnRampPaymentResponse>,
) {
  protected mockKey = ON_RAMP_PAYMENTS_MOCK_KEY

  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
      pagination: override,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async fetch(req: OnRampPaymentsLoadRequest = {}) {
    try {
      const { page = 0 } = req
      const offset = this.calcOffset(page)
      const limit = this.pageSize

      const {
        data: { data },
      } = await onRampApi.listOnRampPayments(
        req.order,
        offset,
        limit,
        req.status,
        req.date?.dateFrom,
        req.date?.dateTo,
        req.projectId,
      )

      if (data) {
        return {
          data: data.data as OnRampPaymentResponse[],
          pagination: data.pagination as Pagination,
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }

  get filter() {
    return new CollectionFilters<OnRampPaymentsCollectionFilters>(
      transactionsOnRampFilters,
      this.load,
    )
  }
}
